import type { PricingCampaignModel } from '@/shared/generated'

import { orderBy } from 'lodash/fp'

import { cn } from '@/shared/lib/utils'

import PricingAlertsGroup from './PricingAlertsGroup'

export type PricingAlertsTreeAlert = {
	id: string
	name: string
	products: number
	est_revenue: number
	est_revenue_share: number
	solution?: {
		description: string
		tooltip: string
		pricingCampaigns: PricingCampaignModel[] | null
		optimizationGroupId: string
	}
}
export type PricingAlertsTree = {
	level: string
	products: number
	alerts: PricingAlertsTreeAlert[]
	est_revenue_share: number
}
type PricingAlertsProps = {
	className?: string
	collapsedByDefault?: boolean
	alertsOf: 'pc' | 'whatif' | 'og' | 'assortment' | 'anchoring'
	alertsTree: PricingAlertsTree[]
	onNavigate?: (ids: string[]) => void
}
export function PricingAlerts({
	className,
	alertsTree,
	alertsOf,
	onNavigate,
	collapsedByDefault,
}: PricingAlertsProps) {
	return (
		<div className={cn('space-y-3', className)}>
			{alertsTree.map(({ level, products, alerts, est_revenue_share }) => (
				<PricingAlertsGroup
					collapsedByDefault={collapsedByDefault}
					alertsOf={alertsOf}
					key={level}
					kind={level}
					count={products}
					percent={est_revenue_share}
					alerts={orderBy(['est_revenue_share'], ['desc'], alerts)}
					onFilterClick={onNavigate}
				/>
			))}
		</div>
	)
}
